import { MprcLocaleType } from "components/locales/locales";
import React from "react";

////////////////////////////////////////////////////////////////////////////////

interface Props {
    theme: any;
    children?: React.ReactNode;
}

type MprcThemeType = {
    theme: MprcLocaleType;
};

export const MprcThemeContext = React.createContext<MprcThemeType>(null!);

export const useMprcTheme = () => React.useContext(MprcThemeContext);

export const MprcThemeProvider: React.FC<Props> = ({ children, theme }) => {
    return (
        <MprcThemeContext.Provider value={{theme}}>
            {children}
        </MprcThemeContext.Provider>
    );
};
